import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RouteService } from 'src/app/core/services/route.service';
import { UtilService } from 'src/app/core/services/util.service';
import { PaymentStore } from 'src/app/core/stores/payment.store';

@Injectable({
  providedIn: 'root'
})
export class VerifiedCustomerGuard implements CanActivate {

  constructor(
    private paymentStore: PaymentStore,
    private utilService: UtilService,
    public routeService: RouteService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.paymentStore.verificationCustomer) {
      return true;
    } else {
      const merchantId = route.params['merchantId'] || this.routeService.getMerchantId();
      this.utilService.navigateToHome(merchantId)
      return false;
    }
  }
}
